import useDictionary from '../dictionaries/context/useDictionary';

export const getCommissionPercentText = (
  gT: ReturnType<typeof useDictionary>['gT'],
  key: string,
  commissionPercent = 0,
) => (!!commissionPercent ? gT(key, { commissionPercent: (commissionPercent * 100).toFixed(2) }) : '');
